import { Grid } from '@mui/material';
import { AddPartnerApplication, CommissionFrequency } from '@prisma/client';
import { ChangeEvent, FC } from 'react';
import { CustomInput } from 'src/components/CustomInput';

export type IEBankDetailsValues = {
    bicNumber: string;
    ibanNumber: string;
    commissionFrequency: CommissionFrequency;
};

type IEBankDetailsProps = {
    values: IEBankDetailsValues;
    errors: IEBankDetailsValues;
    handleChange: (e: ChangeEvent<any>) => void;
    application: AddPartnerApplication;
};

const IEBankDetails: FC<IEBankDetailsProps> = ({ values, errors, handleChange, application }) => (
    <Grid item xs={12} spacing={2} container>
        <Grid item xs={12} lg={6}>
            <CustomInput
                name="bicNumber"
                label="BIC"
                value={values.bicNumber}
                onChange={handleChange}
                error={errors.bicNumber}
            />
        </Grid>
        <Grid item xs={12} lg={6}>
            <CustomInput
                name="ibanNumber"
                label="IBAN"
                value={values.ibanNumber}
                onChange={handleChange}
                error={errors.ibanNumber}
            />
        </Grid>
        <Grid item xs={12} lg={6}>
            <CustomInput
                name="accountName"
                label="Account Name"
                value={application?.pi_legalCompanyName || ''}
                onChange={() => {}}
                disabled
            />
        </Grid>
    </Grid>
);

export default IEBankDetails;
